import sharedConfig from '@web-publish-id/shared/config'
import { BaseProvider } from './base-provider'
import { ProviderAccessTokenCallback } from '../types'

/**
 * Facebook登录提供者
 */
export class FacebookProvider extends BaseProvider {
  protected readonly clientId = sharedConfig.facebookAppId

  constructor() {
    super()
    this.installSDK()
  }

  public installSDK() {
    this.logger.info('Facebook installSDK')

    window['fbAsyncInit'] = () => {
      this.logger.info('Facebook fbAsyncInit')
      window.FB.init({
        appId: sharedConfig.facebookAppId,
        cookie: true,
        xfbml: false,
        version: 'v22.0',
      })
    }

    const script = document.createElement('script')
    script.src = 'https://connect.facebook.net/en_US/sdk.js'
    script.async = true
    script.defer = true
    document.head.appendChild(script)
  }

  /**
   * 授权回调
   * @param callback
   */
  public oAuth(success: ProviderAccessTokenCallback, fail: (e: any) => void) {
    this.logger.info('Facebook oAuth')

    this.login(success, fail)
    return

    // window.FB.getLoginStatus((response) => {
    //   if (response.status === 'connected') {
    //     this.logger.info('Facebook is connected', response)
    //     const accessToken = response.authResponse.accessToken
    //     success(accessToken)
    //     return
    //   } else {
    //     this.login(success, fail)
    //   }
    // })
  }

  private login(success: ProviderAccessTokenCallback, fail: (e: any) => void) {
    window.FB.login(
      (response) => {
        this.logger.info('Facebook oAuth response', response)

        if (response.authResponse && response.authResponse.grantedScopes) {
          success(response.authResponse.accessToken)
        } else {
          this.logger.error('Facebook oAuth error', { response })
          fail(new Error('Facebook login failed'))
        }
      },
      {
        scope: 'public_profile,email',
        return_scopes: true,
      }
    )
  }
}
